let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bk3ho")).then(() => parcelRequire('ikUwV'));